import { components } from '@/shared/api/interfaces';


export type Tournament = components['schemas']['TournamentOutSchema'];
export type TournamentDetails = components['schemas']['TournamentDetailOutSchema'];
export type TournamentTeams = components['schemas']['TournamentDetailOutSchema']['teams'];
export type Reward = components['schemas']['RewardDescriptionOutSchema'];
export type Stage = components["schemas"]["StageOutSchema"];

export type DefaultTournamentProps = {
  tournament: Tournament | TournamentDetails
};

export enum TournamentPhases {
  UPCOMING = "upcoming",
  REGISTRATION_STARTED = "registration_started",
  REGISTRATION_FINISHED = "registration_finished",
  RUNNING = "running",
  FINISHED = "finished",
};
